export const typography = {
  h1: "text-2xl font-bold leading-tight",
  h2: "text-xl font-semibold leading-tight",
  h3: "text-lg font-medium leading-snug",
  body: "text-sm leading-relaxed",
  small: "text-xs leading-relaxed",
  label: "text-sm font-medium",
}

export const colors = {
  primary: {
    main: "text-purple-600",
    hover: "hover:text-purple-700",
    bg: "bg-purple-600",
    bgHover: "hover:bg-purple-700",
    bgLight: "bg-purple-50",
    border: "border-purple-600",
  },
  text: {
    primary: "text-gray-900",
    secondary: "text-gray-600",
    muted: "text-gray-500",
  },
  background: {
    main: "bg-white",
    secondary: "bg-gray-50",
    hover: "hover:bg-gray-100",
  }
}

export const spacing = {
  layout: "p-6",
  section: "space-y-6",
  stack: "space-y-4",
  inline: "space-x-4",
}

export const components = {
  card: "bg-white rounded-lg shadow-sm",
  button: {
    base: "inline-flex items-center rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2",
    primary: "bg-purple-600 text-white hover:bg-purple-700 focus:ring-purple-500",
    secondary: "border border-purple-600 text-purple-600 hover:bg-purple-50 focus:ring-purple-500",
  },
  input: "rounded-md border-gray-300 focus:border-purple-500 focus:ring-purple-500",
}
